import { create } from "zustand";
import { api, Settings, SyncStatus } from "../lib/tauri";
import { useTaskStore } from "./taskStore";
import { useUiStore } from "./uiStore";

interface SyncState {
  status: SyncStatus;
  settings: Settings | null;
  load: () => Promise<void>;
  syncNow: () => Promise<void>;
  saveSettings: (patch: Record<string, unknown>) => Promise<void>;
}

export const useSyncStore = create<SyncState>((set, get) => ({
  status: { state: "unconfigured", lastSyncAt: null, pendingCount: 0, message: "", lastError: null },
  settings: null,
  load: async () => {
    const [status, settings] = await Promise.all([api.getSyncStatus(), api.getSettings()]);
    set({ status, settings });
    useUiStore.getState().setTheme(settings.theme);
  },
  syncNow: async () => {
    // D1 クラウド同期は Notion 設定に非依存。旧 Notion ガード（hasNotionToken /
    // notionDataSourceId が無いと早期 return）を撤去し、常に D1 と同期する。
    const settings = get().settings ?? (await api.getSettings());
    set({ settings });
    set({ status: { ...get().status, state: "syncing", lastError: null } });
    try {
      await api.triggerSync();
    } catch (e) {
      console.error("syncNow failed", e);
      set({
        status: {
          ...get().status,
          state: "error",
          message: "sync failed",
          lastError: e instanceof Error ? e.message : String(e),
        },
      });
    }
    await get().load();
    // 同期完了後にタスクリストもリフレッシュ
    await useTaskStore.getState().load();
  },
  saveSettings: async (patch) => {
    const settings = await api.updateSettings(patch);
    set({ settings });
    useUiStore.getState().setTheme(settings.theme);
  },
}));
